import $ from 'jquery';
import screenSize from './../../../common/screen_size_util';

/* this module affects the top 50 list for annual pages, borders and spacing */

module.exports = function () {
    var eachRow = $('.mic-list-companies__company-row');
    var eachCompany= $('.mic-list-companies__company-info');
    var eachRank= $('.mic-list-companies__individual-company-rank');
    var eachNameContainer = $('.mic-list-companies__company-name-container');
    // var eachName= $('.mic-list-companies__individual-company-name');

    var location = window.location.href;
    var locationArr = location.split('/');
    var year = locationArr.slice(-1)[0];


    $(eachRow).slice(10, 11).css('border-top', 0);

    if (year === "2008") {
        $(eachRow).slice(0, 1).css('border-top', 0);
        $(eachRow).slice(10, 11).css('border-top', '1px solid #cccccc');
        $(eachRow).last().css('border-bottom', '1px solid #cccccc');
    }


};
